// Local type declaration for Digiaccess
declare global {
    interface Window {
        Digiaccess?: {
            toggle: () => void;
            // Add other Digiaccess methods if needed
        };
    }
}

export function init() {
    console.log('[initialized] meta-nav');
    const metaNav = document.querySelector('.meta-nav');
    const accessibilityButton = metaNav?.querySelector('.meta-nav__accessibility-button');

    if (!accessibilityButton) {
        console.warn('Accessibility button not found in meta-nav');
        return;
    }

    // Hide the original opener button (as recommended by provider)
    function hideOpenerButton() {
        const opener = document.getElementById('dAopener');
        if (opener) {
            opener.style.display = '!important';
            opener.style.visibility = 'hidden';
            console.log('dAopener button hidden successfully');
            return true;
        }
        return false;
    }

    // Function to wait for dAopener button to appear
    function waitForOpenerButton(maxAttempts = 50, interval = 100) {
        let attempts = 0;

        const checkForButton = () => {
            attempts++;

            if (hideOpenerButton()) {
                console.log('dAopener found and hidden after', attempts, 'attempts');
                return;
            }

            if (attempts < maxAttempts) {
                setTimeout(checkForButton, interval);
            } else {
                console.warn('dAopener button not found after', maxAttempts, 'attempts');
            }
        };

        checkForButton();
    }

    // Start waiting for the opener button
    waitForOpenerButton();

    // Add event listener to the accessibility button (as recommended by provider)
    accessibilityButton.addEventListener('click', function () {
        console.log('Accessibility button clicked!');

        if (window.Digiaccess) {
            window.Digiaccess.toggle();
            console.log('Digiaccess toggle called successfully');
        } else {
            console.warn('Digiaccess not available');
        }
    });
}